const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  surveyCard: {
    backgroundColor: "#fff",
    height: 146,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    cursor: "pointer",
    "&:hover": {
      transform: `scale(0.98)`,
    },
  },
  filterCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    marginBottom: 18,
  },
  displayCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  },
  actions: {
    ...theme.borderTop,
    paddingTop: 10,
    marginTop: 10,
  },
  surveyTitle: {
    marginTop: 4,
  },
  userHeader: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 20,
  },
  content: {
    ...theme.mainContentMD,
  },
  emptyWrap: {
    background: "#fff",
    padding: "15px",
    width: "100%",
    borderRadius: 8,
  },
  resCard: {
    backgroundColor: "#fff",
    padding: 16,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    // marginBottom: 18,
    ...theme.borderBottom,
  },
  resFooter: {
    // ...theme.borderTop,
    // paddingTop: 10,
    marginTop: 10,
    display: "flex",
    gap: 10,
    justifyContent: "flex-end",
  },
  rating: {
    display: "flex",
    listStyle: "none",
    margin: 0,
    padding: 0,
    gap: 10,
  },
  resBody: {
    paddingTop: 10,
  },
  surveyCardDisabled: {
    background: "#bdbdbd",
    pointerEvents: "none",
  },
  statWrap: {
    display: "flex",
    borderRadius: 8,
    overflow: "hidden",
  },
  customTooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    backdropFilter: "blur(10px)",
    borderRadius: 8,
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
    fontSize: "13px",
    maxWidth: "280px",
    padding: "0",
  },
  customTooltipArrow: {
    color: "rgba(0, 0, 0, 0.9)",
  },
  statCard: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "32px",
  },
  overviewCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "&:not(:last-child)": {
      marginBottom: "25px",
    },
  },
  // Modern OverviewCard styles
  modernOverviewCard: {
    backgroundColor: "#fff",
    padding: 24,
    transition: "all 0.3s ease",
    "&:not(:last-child)": {
      border: "1px solid rgba(0, 0, 0, 0.05)",
    },
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 20,
    marginBottom: 20,
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: 16,
    },
  },
  questionSection: {
    flex: "1 1 60%",
    minWidth: 0,
  },
  questionTitle: {
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: 1.5,
    color: "#1a1a1a",
    margin: 0,
    wordBreak: "break-word",
    marginBottom: 12,
  },
  statsSection: {
    flex: "0 0 40%",
    minWidth: 200,
    "@media (max-width: 768px)": {
      flex: "1 1 100%",
    },
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  statContainer: {
    borderRadius: 8,
    overflow: "hidden",
  },
  statValue: {
    fontSize: 11,
    fontWeight: 600,
    color: "#fff",
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
  },
  // Option Stats styles
  optionStatsContainer: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
  },
  optionStatsTitle: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: 12,
  },
  optionStatsList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  optionStatItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "8px 12px",
    backgroundColor: "#f9fafb",
    borderRadius: 6,
    border: "1px solid rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      transform: "translateX(2px)",
    },
  },
  optionColorIndicator: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    flexShrink: 0,
    border: "2px solid rgba(255, 255, 255, 0.8)",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
  },
  optionLabel: {
    fontSize: "0.875rem",
    color: "#374151",
    fontWeight: 500,
    flex: 1,
    textTransform: "capitalize",
  },
  optionCount: {
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#1f2937",
    backgroundColor: "#e5e7eb",
    padding: "2px 8px",
    borderRadius: 12,
    minWidth: 24,
    textAlign: "center",
  },
  cardFooter: {
    marginTop: 20,
    paddingTop: 16,
    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
  },
  cardFooterWithComments: {
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  commentsSection: {
    width: "100%",
  },
  commentsContainer: {
    marginTop: 8,
  },
  commentsHeader: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#374151",
    marginBottom: 12,
  },
  commentsList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  commentItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    padding: "8px 12px",
    backgroundColor: "#f8f9fa",
    borderRadius: 6,
    border: "1px solid rgba(0, 0, 0, 0.05)",
  },
  commentIcon: {
    fontSize: 16,
    color: "#6b7280",
    marginTop: 2,
    flexShrink: 0,
  },
  commentText: {
    fontSize: "0.875rem",
    lineHeight: 1.5,
    color: "#374151",
    margin: 0,
    wordBreak: "break-word",
  },
  noCommentsText: {
    fontSize: "0.875rem",
    color: "#9ca3af",
    fontStyle: "italic",
    textAlign: "center",
    padding: "16px 0",
  },
  responseSection: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 12px",
    backgroundColor: "#f0f9ff",
    borderRadius: 20,
    border: "1px solid #bfdbfe",
    width: "fit-content",
  },
  responseLabel: {
    fontSize: "0.75rem",
    color: "#1e40af",
    fontWeight: 500,
    margin: 0,
  },
  responseValue: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#1e3a8a",
    margin: 0,
  },
  commentSwitcher: {
    marginBottom: 4,
    "@media print": {
      display: "none",
    },
  },
  borderBottom: {
    "&:not(:last-child)": {
      ...theme.borderBottom,
    },
  },
  overCard: {
    backgroundColor: "#fff",
    padding: 16,
    ...theme.borderBottom,
  },
  overviewFooter: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    justifyContent: "flex-end",
    marginTop: 10,
  },
  overviewFooterJustify: {
    justifyContent: "space-between",
  },
  ratingWrap: {
    display: "flex",
    marginBottom: 0,
  },
  ratingContainer: {
    position: "sticky",
    top: 58,
    zIndex: 1,
  },
  ratingItem: {
    width: `20%`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 40,
    color: "white",
    "& .MuiTypography-root": {
      color: "white",
      fontWeight: 500,
    },
  },
  chartWrap: {
    background: "#fff",
    marginTop: 10,
  },
  headlineCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "&:not(:last-child)": {
      marginBottom: "25px",
    },
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: "120px",
    // Override white text for question cards with white backgrounds
    "& .MuiTypography-root": {
      color: "#0a0a29", // Dark text for readability on white background
    },
  },
  headlineContainer: {
    "@media print": {
      padding: 0,
      margin: 0,
    },
  },
  headlineHeader: {
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  headlineList: {
    marginTop: 18,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  headlineQue: {
    width: "80%",
    "@media print": {
      fontSize: "12px",
    },
  },
  headlineRating: {
    width: "20%",
    textAlign: "right",
    "@media print": {
      fontSize: "13px",
    },
  },
  headlineWrap: {
    "&:not(:last-child)": {
      marginBottom: "10px",
    },
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  lableCard: {
    display: "flex",
    gap: 20,
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  },
  cardPositive: {
    backgroundColor: "#64b5f6", // Light blue to match refined palette
    color: "white",
    "& .MuiTypography-root": {
      color: "white",
      fontWeight: 500,
    },
  },
  cardNeutral: {
    backgroundColor: "#bdbdbd", // Light grey for better neutrality
    color: "white",
    "& .MuiTypography-root": {
      color: "white",
      fontWeight: 500,
    },
  },
  cardNegative: {
    backgroundColor: "#e57373", // Light red to match refined palette
    color: "white",
    "& .MuiTypography-root": {
      color: "white",
      fontWeight: 500,
    },
  },
  headlineProgress: {
    marginTop: "auto",
    paddingTop: 18,
  },
  statusMenu: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  statusMenuItem: {
    backgroundColor: "#fff",
    padding: "7px 12px",
    ...theme.border,
    borderRadius: 5,
    cursor: "pointer",
    textTransform: "capitalize",
  },
  statusMenuItemSelected: {
    backgroundColor: "#C5E3FF",
  },
  specList: {
    display: "flex",
    listStyle: "none",
    gap: 10,
    margin: 0,
    padding: `8px 0px 0px 0px`,
  },
  specItem: {
    display: "flex",
    gap: 4,
  },
  commonFilterCard: {
    backgroundColor: "#fff",
    padding: `12px 16px`,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 18,
    "@media print": {
      display: "none",
    },
  },
  filterList: {
    display: "flex",
    listStyle: "none",
    alignItems: "center",
    margin: 0,
    padding: 0,
  },
  listItem: {
    background: "#fff",
    padding: "6px 20px",
    ...theme.typography.b1,
    cursor: "pointer",
    "&:not(:first-child)": {
      borderLeft: "1px solid #bebebe",
      paddingLeft: 20,
    },
    "&:not(:last-child)": {
      paddingRight: 20,
    },
    display: "flex",
    gap: 4,
    alignItems: "center",
    whiteSpace: "pre",
    textTransform: "capitalize",
  },
  listItemSelected: {
    fontWeight: 700,
    backgroundColor: "#C5E3FF",
  },
  barPositive: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#64b5f6", // Light blue to match refined palette
      // transform: "none !important",
    },
  },
  barNeutral: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#bdbdbd", // Light grey for better neutrality
      // transform: "none !important",
    },
  },
  barNegative: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#e57373", // Light red to match refined palette
      // transform: "none !important",
    },
  },
  bar: {
    border: "1px solid #ababab",
    backgroundColor: "#fff",
  },
  tabContent: {
    marginTop: 18,
  },
  reportCard: {
    display: "none",
    "@media print": {
      display: "block",
      marginBottom: 18,
    },
  },
  actionHeader: {
    marginBottom: 18,
  },
  input: {
    display: "none",
  },
  actionCard: {
    padding: `12px 24px`,
    borderRadius: 0,
  },
  progress: {
    height: 8,
    borderRadius: 8,
    marginTop: 4,
  },
  tableContainer: {
    display: "flex",
    width: "100%",
  },
  tableHeader: {
    borderBottom: "1px solid rgba(195, 194, 194, 0.54)",
  },
  tableHead: {
    width: "14.3%",
    background: "#fff",
    padding: "16px",
    display: "flex",
    gap: 5,
  },
  tableHeadLG: {
    width: "40%",
    background: "#fff",
    padding: "16px",
    display: "flex",
    gap: 5,
  },
  questionCell: {
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  tableRow: {
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(195, 194, 194, 0.54)",
    },
  },
  tableRowFw: {
    width: "100%",
    background: "#fff",
    padding: "16px",
    display: "flex",
    justifyContent: "center",
  },
  resHeader: {
    display: "flex",
  },
  resHeaderItem: {
    flex: "1",
  },
  tableActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 18,
  },
  commentCard: {
    marginLeft: -6,
  },
  commentWrapper: {
    "@media print": {
      display: "none",
    },
  },
  headerActions: {
    display: "flex",
    gap: 10,
  },
  templateCard: {
    ...theme.border,
    display: "flex",
    borderRadius: 4,
    backgroundColor: "#   ",
    "&:not(:last-child)": {
      marginBottom: "15px",
    },
    padding: "8px",
    cursor: "pointer",
  },
  templateSelected: {
    backgroundColor: "rgb(237 244 255)",
  },
  chartCard: {
    padding: 18,
  },
  overallChart: {
    maxWidth: 300,
    margin: "0 auto",
  },
  pieChart: {
    maxWidth: 160,
    margin: "0 auto",
    minHeight: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 12,
    alignItems: "center",
  },
  meanCardWrap: {
    "@media print": {
      display: "block",
    },
  },
  meanCardWrapHidden: {
    "@media print": {
      display: "none",
    },
  },
  reportItem: {
    "@media print": {
      width: "calc(100% - 20px)",
      margin: "10px",
    },
  },
  optionItem: {
    backgroundColor: "#f0f0f0",
    padding: "8px",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:not(:last-child)": {
      marginBottom: "15px",
    },
  },
  synopsisCard: {
    marginTop: "18px",
    padding: "15px",
  },
  root: {
    position: "relative",
    minHeight: "calc(100vh - 200px)",
    padding: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  content: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: theme.spacing(3),
    padding: theme.spacing(2),
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    zIndex: 1000,
  },
  questionCard: {
    padding: theme.spacing(2),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: theme.shadows[4],
    },
  },
  questionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: theme.spacing(2),
  },
  questionContent: {
    flex: 1,
    marginBottom: theme.spacing(2),
  },
  questionFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "auto",
  },
  stickyPredictionReport: {
    position: "sticky",
    top: theme.spacing(2),
    maxHeight: "calc(100vh - 100px)",
  },
  stickyMainContent: {
    position: "relative",
    maxHeight: "calc(100vh - 100px)",
  },
  listingCard: {
    overflowY: "auto",
  },
  editPageContainer: {
    maxWidth: 1000,
    margin: "0 auto",
  },
  commonFilterActions: {
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  filterTitle: {
    ...theme.typography.h2,
    ...theme.typography.bold,
  },
}));
